<template>
  <div id="mb-presentation-grid-electron">
    <!-- <mb-presentation v-if="presentationState"></mb-presentation> -->
    <mb-info :left-pos="3.5" :background-style="'#0054a3'" v-if="info" :info="info"></mb-info>
    <div class="presentation-items">
      <p style="font-size: 3rem">Tablice demonstracyjne</p>
      <div class="presentation-items-scroll">
        <div class="presentation-items-not-full">
          <div
            :id="'presentation-item-' + i1"
            :key="'presentation-grid' + i1"
            v-for="(item, i1) in presentationKeys"
            class="presentation-item"
            :class="{ 'disable-presentation': showData(item) }"
            @click="pleaseShowMePresentation(item)"
          >
            <img :src="giveMeImagePlease('presentation/' + item + '/img.png')" />
            <!-- <div class="tooltip">
              <p v-html="returnTitle(item)"></p>
            </div> -->
            <!-- <p class="presentation-title" :id="'presentation-title-' + i1">
              <span v-html="returnTitle(item)"></span>
            </p> -->
          </div>
        </div>
      </div>
    </div>
    <svg @click="redirectMain" class="home-btn" viewBox="0 0 24 24" fill="white" style="width: 2.5vw; width: 2.5vw">
      <path d="M12 3L2 12h3v8h6v-6h2v6h6v-8h3L12 3zm5 15h-2v-6H9v6H7v-7.81l5-4.5 5 4.5V18z" />
      <path class="center" d="M7 10.19V18h2v-6h6v6h2v-7.81l-5-4.5z" opacity=".3" />
      <path d="M0 0h24v24H0z" fill="none" />
    </svg>
    <!-- <dir @click="redirectMain" class="home-btn" v-if="isWeb || multiconfig">
      <img :src="homeIcon" alt="Home" />
    </dir> -->
    <img class="logo-box" src="./logoMAC_kolor.png" alt="Logo MAC S.A." />
  </div>
</template>
<script>
// import INFO from '../../config/info/tablice.js';
import _ from 'lodash';
import MbInfo from '../MbInfo/MbInfo.vue';
export default {
  name: 'mb-presentation-grid-electron',
  components: {
    MbInfo,
  },
  data: function () {
    return {
      presentationKeys: null,
      info: null,
    };
  },
  // beforeRouteEnter(to, from, next) {
  //   next();
  // },
  mounted() {
    this.init();
  },
  methods: {
    showData(key) {
      const multibookType = this.$store.getters.multibookType;
      let pres = this.$store.getters[`${_.upperFirst(multibookType)}/presentations`];
      let data = pres.get(key);
      if (data.unactive) {
        return true;
      } else return false;
    },
    returnTitle(key) {
      const multibookType = this.$store.getters.multibookType;
      let pres = this.$store.getters[`${_.upperFirst(multibookType)}/presentations`];
      let data = pres.get(key);
      if (data.tooltip) {
        return data.tooltip;
      } else return 'Prezentacja';
    },
    redirectMain() {
      this.$router.push(`/`);
    },
    pleaseShowMePresentation(id) {
      if (this.showData(id)) {
      } else {
        const multibookType = this.$store.getters.multibookType;
        if (this.presentations.get(id).type == 'interactive-lesson') {
          this.$router.push(`/lesson/${multibookType}/${id}`);
        } else {
          this.$router.push(`/presentation/${multibookType}/${id}`);
        }
      }
    },
    giveMeImagePlease(path) {
      try {
        return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
      } catch (err) {
        console.log(err);
      }
    },
    init() {
      try {
        this.info = require('../../config/info/tablice.js').default;
      } catch {
        console.log('%cInfoTablice - error', 'font-weight: bold; background: red; color: white; padding: 0px 10px');
      }
      const multibookType = this.$store.getters.multibookType;
      const pres = this.$store.getters[`${_.upperFirst(multibookType)}/presentations`];
      this.presentationKeys = pres.keys();
    },
  },
  computed: {
    isWeb() {
      return this.$store.getters.isWeb;
    },
    multiconfig() {
      return this.$store.getters.multiconfigTest;
    },
    homeIcon() {
      try {
        return require(`__mainSrcDir/assets/icons/book/headerBar/home-48px.svg`);
      } catch {
        console.log(
          '%cHomeIcon MbPresentationsGridElectron- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
    presentationState() {
      return this.$store.getters.getPresentationState;
    },
    presentations() {
      const multibookType = this.$store.getters.multibookType;
      return this.$store.getters[`${_.upperFirst(multibookType)}/presentations`];
    },
  },
};
</script>

<style lang="sass">
$break-large: 1400px
#mb-presentation-grid-electron
  width: 100vw
  height: 100vh
  background: #0054a3
  overflow: hidden
  color: white
  h1
    color: white
  .presentation-items
    width: 100%
    height: calc(100%)
    text-align: center
    padding-top: 2vmin
    .presentation-items-scroll
      overflow-y: scroll
      max-height: calc(100% - 3rem - 2vmin)
      .presentation-items-not-full
        width: 80%
        margin-left: 10%
        .presentation-item
          box-shadow: .5vh .5vh 2vh 0vh rgba(0,0,0,.5)
          background: white
          max-width: 30vmax
          height: calc(30vmax * 0.5625)
          display: inline-block
          text-align: center
          margin: 3vmin
          position: relative
          transition: .5s
          cursor: pointer
          overflow: hidden
          // @media screen and (max-width: $break-large)
          //   width: 30vmax
          //   height: calc(30vmax * 0.5625)
          &:hover
            transform: scale(1.1)
          .tooltip
            left: 5%
            top: 5%
            width: 90% !important
            height: 90% !important
            display: flex
            align-items: center
            opacity: 1
            justify-content: center
            font-size: 1.2rem
            p
              color: #0054a3
              margin: 0
              opacity: 1
              padding: 0
              text-align: center
              font-size: 1.8rem !important
              @media screen and (max-width: $break-large)
                font-size: 1.6rem !important
          img
            max-width: 100%
            height: 100%
          .presentation-title
            max-height: 50%
            width: 100%
            position: absolute
            bottom: 0
            background: rgba(0,0,0,.5)
            margin: 0
            padding: 0
            // opacity: 0
            transition: .5s
            p
              margin: 0
              padding: 0
.logo-box
  height: 10vw
  position: absolute
  bottom: 1vh
  right: 1vh
  opacity: 0
  display: flex
  justify-content: center

.presentation-items-scroll::-webkit-scrollbar-track
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3)
	background-color: #0054a3

.presentation-items-scroll::-webkit-scrollbar
	width: 10px
	background-color: #0054a3

.presentation-items-scroll::-webkit-scrollbar-thumb
	background-color: #309de4
	border: 2px solid #309de4

.grid-fade-leave-active, .grid-fade-enter-active
  transition: all .5s .5s linear

.grid-fade-leave-to, .grid-fade-enter
  transform: scale(0,0)
  opacity: 0
.home-btn
  position: absolute
  top: 0
  left: 0
  margin: 1rem !important
  padding-left: 0 !important
  padding-right: 0 !important
  transition: all 0.4s ease
  transform: scale(1) !important
  cursor: pointer
  .center
    fill: transparent
  img:hover
      cursor: pointer
      background: url('~@/assets/icons/book/headerBar/home-on48px.svg')
  &:hover
    transform: scale(1) !important
    .center
      fill: white

.disable-presentation
  filter: grayscale(1)
  background: gray !important
  &:hover
    transform: scale(1) !important
</style>
